import { z } from 'zod';
export const COMPLIANCE_POLICY_VERSION = '2026-08-26';
export const ACCOUNT_DELETION_ERROR_CODES = {
    ACTIVE_SUBSCRIPTION: 'active_subscription_blocks_deletion',
};
export const customerPortalResponseSchema = z.object({
    success: z.literal(true),
    data: z.object({
        url: z.url(),
    }),
});
export const registrationConsentSchema = z.object({
    termsAccepted: z.literal(true),
    ageConfirmed: z.literal(true),
});
